import { gql } from "@apollo/client";
import { getClient } from "lib/apolloClient";
import type { EntitlementsType } from "@shared/graphql.types";

export const ENTITLEMENTS_QUERY = gql`
  query entitlements {
    entitlements {
      benefitsSavings {
        totalBenefitsSavings
        categories {
          slug
          title
          value
        }
      }
      redeemedBenefits {
        title
        slug
        value
      }
      productSavings {
        totalProductsSavings
      }
      activeBenefits {
        entitlementName
        activated
        expiresAt
        tracking {
          viewed {
            ... on TrackExperimentViewedEventType {
              event
              properties {
                experiment_id
                experiment_variant
              }
            }
          }
        }
      }
    }
  }
`;

export const getEntitlements = async (): Promise<EntitlementsType> => {
  const client = getClient();

  const response = await client.query<{ entitlements: EntitlementsType }>({
    query: ENTITLEMENTS_QUERY,
    fetchPolicy: "cache-first",
    context: {
      sessionStrategy: "REDIRECT_TO_LOGIN"
    }
  });

  return response.data.entitlements;
};
